/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StringFieldFromJSON, StringFieldToJSON, } from './StringField';
/**
 * Check if a given object implements the ServizioDiPagementoSection interface.
 */
export function instanceOfServizioDiPagementoSection(value) {
    let isInstance = true;
    return isInstance;
}
export function ServizioDiPagementoSectionFromJSON(json) {
    return ServizioDiPagementoSectionFromJSONTyped(json, false);
}
export function ServizioDiPagementoSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'costiDiAttivazione': !exists(json, 'costiDiAttivazione') ? undefined : StringFieldFromJSON(json['costiDiAttivazione']),
        'canoneDiAbbonamentoSerivizio': !exists(json, 'canoneDiAbbonamentoSerivizio') ? undefined : StringFieldFromJSON(json['canoneDiAbbonamentoSerivizio']),
        'bollettiniInContanti': !exists(json, 'bollettiniInContanti') ? undefined : StringFieldFromJSON(json['bollettiniInContanti']),
        'bollettiniConStrumentiDiPagamento': !exists(json, 'bollettiniConStrumentiDiPagamento') ? undefined : StringFieldFromJSON(json['bollettiniConStrumentiDiPagamento']),
        'bollettinoFrecciaInContanti': !exists(json, 'bollettinoFrecciaInContanti') ? undefined : StringFieldFromJSON(json['bollettinoFrecciaInContanti']),
        'mavRavInContanti': !exists(json, 'mavRavInContanti') ? undefined : StringFieldFromJSON(json['mavRavInContanti']),
        'mavRavConStrumentiDiPagamento': !exists(json, 'mavRavConStrumentiDiPagamento') ? undefined : StringFieldFromJSON(json['mavRavConStrumentiDiPagamento']),
        'f24InContanti': !exists(json, 'f24InContanti') ? undefined : StringFieldFromJSON(json['f24InContanti']),
        'f24conStrumentiDiPagamento': !exists(json, 'f24conStrumentiDiPagamento') ? undefined : StringFieldFromJSON(json['f24conStrumentiDiPagamento']),
        'ricaricaEntiInContanti': !exists(json, 'ricaricaEntiInContanti') ? undefined : StringFieldFromJSON(json['ricaricaEntiInContanti']),
        'ricaricaEntiConStrumentidiPagamento': !exists(json, 'ricaricaEntiConStrumentidiPagamento') ? undefined : StringFieldFromJSON(json['ricaricaEntiConStrumentidiPagamento']),
        'ricaricheTecnologiche': !exists(json, 'ricaricheTecnologiche') ? undefined : StringFieldFromJSON(json['ricaricheTecnologiche']),
        'pagoPaInContanti': !exists(json, 'pagoPaInContanti') ? undefined : StringFieldFromJSON(json['pagoPaInContanti']),
        'pagoPaConStrumentiDiPagamento': !exists(json, 'pagoPaConStrumentiDiPagamento') ? undefined : StringFieldFromJSON(json['pagoPaConStrumentiDiPagamento']),
        'pagoPaPraInContanti': !exists(json, 'pagoPaPraInContanti') ? undefined : StringFieldFromJSON(json['pagoPaPraInContanti']),
        'pagoPaPraConStrumentiDiPagamento': !exists(json, 'pagoPaPraConStrumentiDiPagamento') ? undefined : StringFieldFromJSON(json['pagoPaPraConStrumentiDiPagamento']),
        'pagoPaBolloAutoInContanti': !exists(json, 'pagoPaBolloAutoInContanti') ? undefined : StringFieldFromJSON(json['pagoPaBolloAutoInContanti']),
        'pagoPaBolloAutoConStumentiDiPagamento': !exists(json, 'pagoPaBolloAutoConStumentiDiPagamento') ? undefined : StringFieldFromJSON(json['pagoPaBolloAutoConStumentiDiPagamento']),
        'bolloAutoInContanti': !exists(json, 'bolloAutoInContanti') ? undefined : StringFieldFromJSON(json['bolloAutoInContanti']),
        'bolloAutoConStrumentiDiPagamento': !exists(json, 'bolloAutoConStrumentiDiPagamento') ? undefined : StringFieldFromJSON(json['bolloAutoConStrumentiDiPagamento']),
        'bollettini': !exists(json, 'bollettini') ? undefined : StringFieldFromJSON(json['bollettini']),
        'bollettinoFreccia': !exists(json, 'bollettinoFreccia') ? undefined : StringFieldFromJSON(json['bollettinoFreccia']),
        'mavRav': !exists(json, 'mavRav') ? undefined : StringFieldFromJSON(json['mavRav']),
        'delegaF24': !exists(json, 'delegaF24') ? undefined : StringFieldFromJSON(json['delegaF24']),
        'ricaricaEnti': !exists(json, 'ricaricaEnti') ? undefined : StringFieldFromJSON(json['ricaricaEnti']),
        'pagoPa': !exists(json, 'pagoPa') ? undefined : StringFieldFromJSON(json['pagoPa']),
        'pagoPaPra': !exists(json, 'pagoPaPra') ? undefined : StringFieldFromJSON(json['pagoPaPra']),
        'pagoPaBolloAuto': !exists(json, 'pagoPaBolloAuto') ? undefined : StringFieldFromJSON(json['pagoPaBolloAuto']),
        'bolloAuto': !exists(json, 'bolloAuto') ? undefined : StringFieldFromJSON(json['bolloAuto']),
    };
}
export function ServizioDiPagementoSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'costiDiAttivazione': StringFieldToJSON(value.costiDiAttivazione),
        'canoneDiAbbonamentoSerivizio': StringFieldToJSON(value.canoneDiAbbonamentoSerivizio),
        'bollettiniInContanti': StringFieldToJSON(value.bollettiniInContanti),
        'bollettiniConStrumentiDiPagamento': StringFieldToJSON(value.bollettiniConStrumentiDiPagamento),
        'bollettinoFrecciaInContanti': StringFieldToJSON(value.bollettinoFrecciaInContanti),
        'mavRavInContanti': StringFieldToJSON(value.mavRavInContanti),
        'mavRavConStrumentiDiPagamento': StringFieldToJSON(value.mavRavConStrumentiDiPagamento),
        'f24InContanti': StringFieldToJSON(value.f24InContanti),
        'f24conStrumentiDiPagamento': StringFieldToJSON(value.f24conStrumentiDiPagamento),
        'ricaricaEntiInContanti': StringFieldToJSON(value.ricaricaEntiInContanti),
        'ricaricaEntiConStrumentidiPagamento': StringFieldToJSON(value.ricaricaEntiConStrumentidiPagamento),
        'ricaricheTecnologiche': StringFieldToJSON(value.ricaricheTecnologiche),
        'pagoPaInContanti': StringFieldToJSON(value.pagoPaInContanti),
        'pagoPaConStrumentiDiPagamento': StringFieldToJSON(value.pagoPaConStrumentiDiPagamento),
        'pagoPaPraInContanti': StringFieldToJSON(value.pagoPaPraInContanti),
        'pagoPaPraConStrumentiDiPagamento': StringFieldToJSON(value.pagoPaPraConStrumentiDiPagamento),
        'pagoPaBolloAutoInContanti': StringFieldToJSON(value.pagoPaBolloAutoInContanti),
        'pagoPaBolloAutoConStumentiDiPagamento': StringFieldToJSON(value.pagoPaBolloAutoConStumentiDiPagamento),
        'bolloAutoInContanti': StringFieldToJSON(value.bolloAutoInContanti),
        'bolloAutoConStrumentiDiPagamento': StringFieldToJSON(value.bolloAutoConStrumentiDiPagamento),
        'bollettini': StringFieldToJSON(value.bollettini),
        'bollettinoFreccia': StringFieldToJSON(value.bollettinoFreccia),
        'mavRav': StringFieldToJSON(value.mavRav),
        'delegaF24': StringFieldToJSON(value.delegaF24),
        'ricaricaEnti': StringFieldToJSON(value.ricaricaEnti),
        'pagoPa': StringFieldToJSON(value.pagoPa),
        'pagoPaPra': StringFieldToJSON(value.pagoPaPra),
        'pagoPaBolloAuto': StringFieldToJSON(value.pagoPaBolloAuto),
        'bolloAuto': StringFieldToJSON(value.bolloAuto),
    };
}
